<script setup>
import { inject, ref, onBeforeMount, provide } from 'vue';
import { props as filialPadrao, fillFilial } from '@/modules/configuracoes/filial/store';
import { setSession, SessionService } from '@/modules/session/store/index';
import { useRouter } from 'vue-router';
import { KeysService, serialPrincipal, diasLiberacao, liberarMaisTarde, sistemaLiberadoDias } from '@/modules/configuracoes/keys/store/';
import { common } from '@/utils';
import { LiberacaoMessageEnumerator, Tela, TipoEnum } from '@/enums/configuracao';
import { valPermissaoNegativaBooleanCommon } from '@/modules/configuracoes/permissionValidator/store';

const $cookies = inject('$cookies');
const router = useRouter();
const loadingApp = ref();
provide('loadingApp', loadingApp);
const filial = $cookies.get('Filial');
const liberarMaisTardeCookies = $cookies.get('liberarMaisTarde');
const sistemaLiberadoDiasCookies = $cookies.get('sistemaLiberadoDias');
const statusMessage = ref();

async function verificandoAvisoEPermissao() {
  await valPermissaoNegativaBooleanCommon(Tela.NaoExibirAvisoVencimento.valueEnum, TipoEnum.Permitir.valueEnum)
    .then((data) => {
      if (data || (diasLiberacao.value < 0)) {
        router.push({ name: 'liberacaoAviso' });
      }
    });
}

async function checandoLiberacao() {
  const inputModel = {
    serial: serialPrincipal.value,
    filial__Codigo: filialPadrao.value.filial.codigo,
  };
  await KeysService.chegandoLiberacaoDias(inputModel)
    .then((data) => {
      diasLiberacao.value = data;
      if (sistemaLiberadoDiasCookies) {
        sistemaLiberadoDias.value = sistemaLiberadoDiasCookies;
        common.setCookie('sistemaLiberadoDias', null, '0s');
      }
      if (liberarMaisTardeCookies) {
        liberarMaisTarde.value = true;
        common.setCookie('liberarMaisTarde', null, '0s');
      } else if (diasLiberacao.value <= LiberacaoMessageEnumerator.DiasParaFecharTelaAposSolicitarPagamento.valueEnum && !liberarMaisTarde.value) {
        verificandoAvisoEPermissao();
      }
    }).catch((error) => {
      statusMessage.value.setMessageBody(error);
    });
}

async function validKeys() {
  await KeysService.validSerial(filialPadrao.value.filial.codigo)
    .then((data) => {
      serialPrincipal.value = data;
      checandoLiberacao();
    })
    .catch(() => {
      router.push({ name: 'serial' });
    });
}

async function verifyFilial() {
  if (!filial) {
    router.push('/filial/selecionar/');
  } else if (!filialPadrao) {
    fillFilial(filial);
  }
}

async function getSession() {
  const publicToken = $cookies.get('PublicToken');

  if (publicToken) {
    await SessionService.get(filial)
      .then(((data) => {
        setSession(data);
      }));
  } else {
    window.location.href = 'https://auth.vr.app.br/';
  }
}

onBeforeMount(async () => {
  await Promise.all([await getSession(), await verifyFilial()])
    .then(() => {
      if (filialPadrao.value.filial.codigo > 0) {
        validKeys();
      }
    });
});
</script>

<template>
  <slot />
</template>
